import eth from './eth.config';
import api from './api.config';
import sites from './sites.config';
import sitelocked from './sitelocked.config';
import ga from './ga.config';
import cognito from './cognito.config';
import s3 from './s3.config';
import init from './init.config';
import paypal from './paypal.config';

const env = process.env.REACT_APP_ENV || process.env.NODE_ENV;

export default {
  init: function() {
    init(this);
  },
  env: env,
  eth: eth[env],
  api: api[env],
  sites: sites[env],
  sitelocked: sitelocked[env],
  ga: ga[env],
  cognito: cognito[env],
  s3: s3[env],
  paypal: paypal[env],
};
